import { render, staticRenderFns } from "./NewsDetail55.vue?vue&type=template&id=406d0dff&scoped=true"
import script from "./NewsDetail55.vue?vue&type=script&lang=js"
export * from "./NewsDetail55.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail55.vue?vue&type=style&index=0&id=406d0dff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d0dff",
  null
  
)

export default component.exports